import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tasktype_returndata } from 'src/types/tasktype_returndata'; 
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-marketingbirthday',
  templateUrl: './marketingbirthday.component.html',
  styleUrls: ['./marketingbirthday.component.css']
})
export class MarketingbirthdayComponent {

  ListTasks: any = [];
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  httpResponse: any;
  DisabledClass: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  constructor(
    private http: HttpClient, private router: Router, private messageService: MessageService, private globalService: GlobalService) { 
    }

    ngOnInit(): void {

      this.globalService.setSmallScreenMenu(false);

      localStorage.removeItem("screenMemoryBookingss");
      localStorage.removeItem("screenMemoryEvents");
      
      let userid = localStorage.getItem("SmartUserID");
  
      this.http.get(bmxurl + "User/" + userid).subscribe(response => {
        this.httpResponse =  (response as users_returndata)
        if(this.httpResponse.succeeded)
        {
          let user = this.httpResponse.data;
  
          if(getAccess("TASKS", user)){
            this.AccessAllowed = true;
            this.loadgrid(false);
          }
  
          this.CompletedLoading = true;
  
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
      });
  
    }
  
    toggleDisabled(){
      this.loadgrid(!this.isDisabled);
    }
  
    disableData(TaskID)
    {
      this.http.delete(bmxurl + "Task/" + this.VenueID + "/" + TaskID).subscribe(response => {
        this.httpResponse = response
        if(this.httpResponse.succeeded == true)
        {
          this.messageService.add({severity:'success', summary:'Disabled', detail:'Task Type successfully disabled'});
          this.router.navigateByUrl("/tasklist");
  
          this.loadgrid(false);
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Class'});
      })
    }
    
    loadgrid(showdisabled: boolean)
    {

      // var testdata = {
      //   "name": "Birthdays 1 - 5",
      //   "campaignid": "f77e4993-e498-49fe-a059-9517ee8bed09",
      //   "startdate": new Date("2024-01-01"),
      //   "enddate": new Date("2024-12-31"),
      //   "totalrevenue": 1242.33,
      // }
      // this.ListTasks.push(testdata);

      // testdata = {
      //   "name": "Birthdays 6 - 10",
      //   "campaignid": "cc142eee-aad9-4962-84bb-753aae14ee93",
      //   "startdate": new Date("2024-01-01"),
      //   "enddate": new Date("2024-12-31"),
      //   "totalrevenue": 936.62,
      // }
      // this.ListTasks.push(testdata);

      // testdata = {
      //   "name": "Birthdays 11 - 15",
      //   "campaignid": "a7dcaa6c-cb4e-4f95-8f05-0a440ae00931",
      //   "startdate": new Date("2024-01-01"),
      //   "enddate": new Date("2024-12-31"),
      //   "totalrevenue": 2086.12,
      // }
      // this.ListTasks.push(testdata);
      
      this.http.get(bmxurl + "MarketingTaskTypeList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
        this.httpResponse = response
        if(this.httpResponse.succeeded)
        {
          this.ListTasks = (response as tasktype_returndata);
  
          if ((response as tasktype_returndata).messages.length > 0)
          {
            (response as tasktype_returndata).messages.forEach(error => {
              this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
            });
          }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting Tasks, error: ' + this.httpResponse.messages[0]});
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Tasks, error: ' + error.messages});
      });
    }
  
    editData(EditData)
    {
      let TaskID = EditData;
      this.router.navigateByUrl("/marketingbirthdayedit/" + TaskID);
    }
  
    disableMulti()
    {
      // this.selectedItems.forEach(element => {
  
      // this.http.delete(bmxurl + "Task/" + this.VenueID + "/" + element.TaskID).subscribe(response => {
      //   this.httpResponse = response
      //   if(this.httpResponse.succeeded)
      //   {
      //     this.loadgrid(false);
      //   } 
      //   else{
      //     this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error disabling Tasks, error: ' + this.httpResponse.messages[0]});
      //   }
      // }, error => {
      //   this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error disabling Tasks, error: ' + error.messages});
      // })
      // });
      
    }
  

}
